import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "code-of-conduct"
    }}>{`Code of Conduct`}</h1>
    <h2 {...{
      "id": "1-purpose"
    }}>{`1. Purpose`}</h2>
    <p>{`A primary goal of Design Systems Coalition NYC is to be inclusive to the largest number of members, with the most varied and diverse backgrounds possible. As such, we are committed to providing a friendly, safe and welcoming environment for all, regardless of gender, sexual orientation, ability, ethnicity, socioeconomic status, and religion (or lack thereof).`}</p>
    <p>{`This code of conduct outlines our expectations for all those who participate in our community, as well as the consequences for unacceptable behavior.`}</p>
    <p>{`We invite all those who participate in Design Systems Coalition NYC to help us create safe and positive experiences for everyone.`}</p>
    <h2 {...{
      "id": "2-open-source-citizenship"
    }}>{`2. Open Source Citizenship`}</h2>
    <p>{`A supplemental goal of this Code of Conduct is to increase open source citizenship by encouraging participants to recognize and strengthen the relationships between our actions and their effects on our community.`}</p>
    <p>{`Communities mirror the societies in which they exist and positive action is essential to counteract the many forms of inequality and abuses of power that exist in society.`}</p>
    <p>{`If you see someone who is making an extra effort to ensure our community is welcoming, friendly, and encourages all participants to contribute to the fullest extent, we want to know.`}</p>
    <h2 {...{
      "id": "3-expected-behavior"
    }}>{`3. Expected Behavior`}</h2>
    <p>{`The following behaviors are expected and requested of all community members:`}</p>
    <ul>
      <li parentName="ul">{`Participate in an authentic and active way. In doing so, you contribute to the health and longevity of this community.`}</li>
      <li parentName="ul">{`Exercise consideration and respect in your speech and actions.`}</li>
      <li parentName="ul">{`Attempt collaboration before conflict.`}</li>
      <li parentName="ul">{`Refrain from demeaning, discriminatory, or harassing behavior and speech.`}</li>
      <li parentName="ul">{`Be mindful of your surroundings and of your fellow participants. Alert `}<a parentName="li" {...{
          "href": "https://www.meetup.com/NYC-Design-Systems-Coalition/members/?op=leaders"
        }}>{`community leaders`}</a>{` if you notice a dangerous situation, someone in distress, or violations of this Code of Conduct, even if they seem inconsequential.`}</li>
      <li parentName="ul">{`Remember that community event venues may be shared with members of the public; please be respectful to all patrons of these locations.`}</li>
    </ul>
    <h2 {...{
      "id": "4-unacceptable-behavior"
    }}>{`4. Unacceptable Behavior`}</h2>
    <p>{`The following behaviors are considered harassment and are unacceptable within our community:`}</p>
    <ul>
      <li parentName="ul">{`Violence, threats of violence or violent language directed against another person.`}</li>
      <li parentName="ul">{`Sexist, racist, homophobic, transphobic, ableist or otherwise discriminatory jokes and language.`}</li>
      <li parentName="ul">{`Posting or displaying sexually explicit or violent material.`}</li>
      <li parentName="ul">{`Posting or threatening to post other people’s personally identifying information ("doxing").`}</li>
      <li parentName="ul">{`Personal insults, particularly those related to gender, sexual orientation, race, religion, or disability.`}</li>
      <li parentName="ul">{`Inappropriate photography or recording.`}</li>
      <li parentName="ul">{`Inappropriate physical contact. You should have someone’s consent before touching them.`}</li>
      <li parentName="ul">{`Unwelcome sexual attention. This includes, sexualized comments or jokes; inappropriate touching, groping, and unwelcomed sexual advances.`}</li>
      <li parentName="ul">{`Deliberate intimidation, stalking or following (online or in person).`}</li>
      <li parentName="ul">{`Advocating for, or encouraging, any of the above behavior.`}</li>
      <li parentName="ul">{`Sustained disruption of community events, including talks and presentations.`}</li>
    </ul>
    <h2 {...{
      "id": "5-consequences-of-unacceptable-behavior"
    }}>{`5. Consequences of Unacceptable Behavior`}</h2>
    <p>{`Unacceptable behavior from any community member, including sponsors and those with decision-making authority, will not be tolerated.`}</p>
    <p>{`Anyone asked to stop unacceptable behavior is expected to comply immediately.`}</p>
    <p>{`If a community member engages in unacceptable behavior, the `}<a parentName="p" {...{
        "href": "https://www.meetup.com/NYC-Design-Systems-Coalition/members/?op=leaders"
      }}>{`community organizers`}</a>{` may take any action they deem appropriate, up to and including a temporary ban or permanent expulsion from the community without warning (and without refund in the case of a paid event).`}</p>
    <h2 {...{
      "id": "6-reporting-guidelines"
    }}>{`6. Reporting Guidelines`}</h2>
    <p>{`If you are subject to or witness unacceptable behavior, or have any other concerns, please notify a `}<a parentName="p" {...{
        "href": "https://www.meetup.com/NYC-Design-Systems-Coalition/members/?op=leaders"
      }}>{`community organizer`}</a>{` as soon as possible: designsystems.nyc@gmail.com.`}</p>
    <p>{`Additionally, community organizers are available to help community members engage with local law enforcement or to otherwise help those experiencing unacceptable behavior feel safe. In the context of in-person events, organizers will also provide escorts as desired by the person experiencing distress.`}</p>
    <h2 {...{
      "id": "7-addressing-grievances"
    }}>{`7. Addressing Grievances`}</h2>
    <p>{`If you feel you have been falsely or unfairly accused of violating this Code of Conduct, you should notify Design Systems Coalition NYC with a concise description of your grievance. Your grievance will be handled in accordance with our existing governing policies.`}</p>
    <h2 {...{
      "id": "8-scope"
    }}>{`8. Scope`}</h2>
    <p>{`We expect all community participants (contributors, paid or otherwise; sponsors; and other guests) to abide by this Code of Conduct in all community venues–online and in-person–as well as in all one-on-one communications pertaining to community business.`}</p>
    <p>{`This code of conduct and its related procedures also applies to unacceptable behavior occurring outside the scope of community activities when such behavior has the potential to adversely affect the safety and well-being of community members.`}</p>
    <h2 {...{
      "id": "9-contact-info"
    }}>{`9. Contact info`}</h2>
    <p>{`designsystems.nyc@gmail.com`}</p>
    <h2 {...{
      "id": "10-license-and-attribution"
    }}>{`10. License and attribution`}</h2>
    <p>{`This Code of Conduct is distributed under a `}<a parentName="p" {...{
        "href": "http://creativecommons.org/licenses/by-sa/3.0/"
      }}>{`Creative Commons Attribution-ShareAlike license`}</a>{`.`}</p>
    <p>{`Portions of text derived from the `}<a parentName="p" {...{
        "href": "https://www.djangoproject.com/conduct/"
      }}>{`Django Code of Conduct`}</a>{` and the `}<a parentName="p" {...{
        "href": "http://geekfeminism.wikia.com/wiki/Conference_anti-harassment/Policy"
      }}>{`Geek Feminism Anti-Harassment Policy`}</a>{`.`}</p>
    <p>{`Retrieved on November 22, 2016 from `}<a parentName="p" {...{
        "href": "http://citizencodeofconduct.org/"
      }}>{`http://citizencodeofconduct.org/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      